import React from 'react';
import moment from 'moment';
import cx from 'classnames';
import {IconButton, Box} from '@material-ui/core';
import DatePicker from './DatePicker';

import {DatePickerProps} from './types';

import {useStyles} from './RangePicker.styles';

const DayRangePicker = ({
    isPreselection,
    selectedDate,
    startDate,
    endDate,
    ...props
}: DatePickerProps) => {
    const classes = useStyles();

    const renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth) => {
        const mDate = moment(date);
        const isFuture = mDate.isAfter(moment(), 'day');
        const isSelectedDay = mDate.isSame(selectedDate, 'day');
        const isDayBetween = mDate.isBetween(startDate, endDate);
        const isFirstDay = mDate.isSame(startDate, 'day');
        const isLastDay = mDate.isSame(endDate, 'day');
        const isInterval = !moment(startDate).isSame(endDate, 'day');

        const dayClassName = cx(classes.day, {
            [classes.nonCurrentMonthDay]: !dayInCurrentMonth,
            [classes.disabledFutureDay]: isFuture && dayInCurrentMonth,
            [classes.preselectedEmphasis]:
                isPreselection && isInterval && (isFirstDay || isLastDay),
            [classes.emphasis]: !isPreselection && isInterval && (isFirstDay || isLastDay)
        });

        // Styles before first calendar click
        const preselectedWrapperClassName = cx({
            [classes.preselectedActiveHighlight]: !isInterval && isSelectedDay,
            [classes.preselectedHighlight]: isDayBetween && !isLastDay,
            [classes.preselectedFirstHighlight]: isInterval && isFirstDay,
            [classes.preselectedLastHighlight]: isInterval && isLastDay
        });

        // Styles after first calendar click
        const wrapperClassName = cx({
            [classes.activeHighlight]: !isInterval && isSelectedDay,
            [classes.highlight]: isDayBetween && !isLastDay,
            [classes.firstHighlight]: isInterval && isFirstDay,
            [classes.lastHighlight]: isInterval && isLastDay
        });

        return (
            <Box className={isPreselection ? preselectedWrapperClassName : wrapperClassName}>
                <IconButton className={dayClassName}>
                    <span>{mDate.format('D')}</span>
                </IconButton>
            </Box>
        );
    };

    return <DatePicker renderDay={renderWrappedWeekDay} {...props} />;
};

export default DayRangePicker;
